import { en } from "./languages/english";
import { es } from "./languages/spanish";

const resources = {
    en,
    es
};

export default resources;